import { Navigate, RouteObject } from 'react-router-dom'

import Layout from '@/App'
import NotFound from '@/views/Error/404'

import { generateElement } from './helper'

const routeArray = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true, // 设置为默认子路由
        element: <Navigate to="/home" replace />,
      },

      {
        path: 'home',
        children: [
          {
            path: 'category',
          },
          {
            path: 'model',
          },
          {
            path: 'author',
          },
          {
            path: 'opus',
          },
          {
            path: 'favorite',
            meta: {
              permission: true,
            },
          },
        ],
      },
      {
        path: 'model',
        children: [
          {
            path: 'submit',
          },
          {
            path: 'submitorder',
          },
        ],
      },
      {
        path: 'about',
      },
      {
        path: 'material',
      },
      {
        path: 'material/detail',
      },
      {
        path: 'scan',

        children: [
          {
            path: 'success',
          },
          {
            path: 'submit',
          },
        ],
      },
      {
        path: 'wallet',
        meta: {
          permission: true,
        },
      },

      {
        path: 'payment',
      },
      {
        path: 'personalcenter',
        meta: {
          permission: true,
        },
      },
      {
        path: 'drive',
        meta: {
          permission: true,
        },
      },
      {
        path: 'shoppingcart',
      },
      {
        // 工单 #651：PC 官网端消息中心（站内信展示与已读回执）
        path: 'messagecenter',
        meta: {
          permission: true,
        },
      },
      {
        // 扁平路由，避免嵌套 index 不渲染导致空白或误跳首页
        path: 'print',
        meta: {
          permission: false,
        },
      },
      {
        path: 'print/submitorder',
        meta: { permission: false },
      },
      {
        path: 'print/placeorder',
        meta: { permission: false },
      },
      {
        path: 'print/paymentmethod',
        meta: { permission: false },
      },
      {
        path: 'order',
        meta: {
          permission: true,
        },
        children: [
          {
            path: 'placeorder',
          },
          {
            path: 'submitorder',
          },
          {
            path: 'orderDetail',
          },
          {
            // 工单 #644：PC 官网端售后中心（复用小程序售后查询端点）
            path: 'afterSales',
          },
        ],
      },
      // AI 生成：扁平路由，避免嵌套 + 缺少 views/AI/index.tsx 导致无法访问
      {
        path: 'ai/imageTo3d',
        meta: {
          permission: true,
        },
      },
      {
        path: 'ai/pricing',
      },
      {
        path: 'ai/member',
        meta: {
          permission: true,
        },
      },
      {
        path: 'login',
        // 新增路由跳转到微信扫码注册页面
        children: [
          {
            path: 'wechatregistercom',
          },
          // 绑定手机号页面
          {
            path: 'bindphonenumber',
          },

          // 新增微信扫码登录页面获取code
          {
            path: 'login_wechat_code',
          },
        ],
      },
      //  通配路由必须放在最后
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]

export const routes = generateElement(routeArray) as RouteObject[]
